import { Map } from 'immutable'

import { WHO_AM_I, SET_ADMINS, SET_LOADING_ADMINS } from '../actions'
import { SET_ROLES } from '../actions/adminActions'

export const initialState = new Map({
  me: null,
  count: null,
  admins: [],
  roles: {},
  loadingAdmins: false
})

const adminReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case WHO_AM_I:
      return state.set('me', action.data)
    case SET_ADMINS:
      return state.set('admins', action.data.results).set('count', action.data.count)
    case SET_ROLES:
      return state.set('roles', {
        ...state.get('roles'),
        [action.key]: {
          results: action.data.results,
          count: action.data.count
        }
      })
    case SET_LOADING_ADMINS:
      return state.set('loadingAdmins', action.data)
    default:
      return state
  }
}

export default adminReducer
